import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from 'reactstrap';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import facturasApiService from '../../services/http/facturasApiService';

const ModalAñadir = ({ isOpen, toggle, empresaId, idFactura, update, setUpdate }) => {
  const [newRow, setNewRow] = useState({
    descripcion: '',
    precio: '',
    unidades: '1',
    importe: '',
    impuesto: '',
  });

  const [isSaving, setIsSaving] = useState(false);
  const [saveMessage, setSaveMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Actualizar el estado
    const updatedRow = { ...newRow, [name]: value };

    // Calcular importe automáticamente si cambia precio o unidades
    if (name === 'precio' || name === 'unidades') {
      const precio = parseFloat(name === 'precio' ? value : updatedRow.precio) || 0;
      const unidades = parseFloat(name === 'unidades' ? value : updatedRow.unidades) || 1;
      updatedRow.importe = (precio * unidades).toFixed(2);
    }

    setNewRow(updatedRow);
  };

  const handleSave = async () => {
    setIsSaving(true);
    setSaveMessage('');
    await facturasApiService.guardarDetallesFactura({
      headquarter: empresaId,
      formData: newRow,
      idFactura,
    });

    setSaveMessage('Guardado exitoso'); // Notifica al componente padre para actualizar la tabla
    // Cerrar el modal después de 3 segundos
    setTimeout(() => {
      toggle(); // Cierra el modal
    }, 3000);

    setUpdate(!update); // Actualiza el estado para reflejar los cambios en la tabla
    setIsSaving(false);
  };
  const isFormValid = Object.values(newRow).every((val) => val.trim() !== '');

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>Añadir Nuevo Registro</ModalHeader>
      <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <Form>
          <FormGroup>
            <Label>
              Descripción <span style={{ color: 'red' }}>*</span>
            </Label>
            <Input
              type="textarea"
              name="descripcion"
              value={newRow.descripcion}
              onChange={handleChange}
              disabled={isSaving}
              required
              style={{ minHeight: '100px' }}
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Precio <span style={{ color: 'red' }}>*</span>
            </Label>
            <Input
              type="number"
              name="precio"
              value={newRow.precio}
              onChange={handleChange}
              disabled={isSaving}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Unidades <span style={{ color: 'red' }}>*</span>
            </Label>
            <Input
              type="number"
              name="unidades"
              value={newRow.unidades}
              onChange={handleChange}
              disabled={isSaving}
              required
              min="1"
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Importe <span style={{ color: 'red' }}>*</span>
            </Label>
            <Input
              type="number"
              name="importe"
              value={newRow.importe}
              onChange={handleChange}
              disabled
              required
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Impuesto <span style={{ color: 'red' }}>*</span>
            </Label>
            <Input
              type="number"
              name="impuesto"
              value={newRow.impuesto}
              onChange={handleChange}
              disabled={isSaving}
              required
            />
          </FormGroup>
        </Form>
        {saveMessage && (
          <p
            className="text-center mt-2"
            style={{ color: saveMessage.includes('Error') ? 'red' : 'green' }}
          >
            {saveMessage}
          </p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={!isFormValid || isSaving}>
          {isSaving ? <Spinner size="sm" /> : <Icon.Save size={16} />} Guardar
        </Button>
        <Button color="danger" onClick={toggle} disabled={isSaving}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ModalAñadir.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  empresaId: PropTypes.string.isRequired, // Identificador de la empresa
  idFactura: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  update: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  setUpdate: PropTypes.func,
};

export default ModalAñadir;
